export default {
    message: {
        hello: '你好世界',
        welcome: '欢迎使用我们的应用'
    },
    menu: {
        home: '首页',
        about: '关于',
        contact: '联系我们'
    },
    button: {
        confirm: '确定',
        cancel: '取消'
    }
}